import React, { useState, useEffect } from "react";
import { ToggleContainer, LeftButton, RightButton, Slider } from "./style";

const IeltsToggle = () => {
  const [active, setActive] = useState(0); // 0 for General, 1 for Academic

  useEffect(() => {
    // Check if there's a stored preference
    const ieltsType = localStorage.getItem("ielts-type");
    if (ieltsType === "academic") {
      setActive(1);
    } else {
      // Default to General
      setActive(0);
    }
  }, []);

  const handleClick = (value) => {
    if (active === value) {
      return;
    }
    
    // Update localStorage and state
    const newIeltsType = value === 1 ? "academic" : "general";
    localStorage.setItem("ielts-type", newIeltsType);
    setActive(value);
    
    // Dispatch a custom event to notify other components about the IELTS type change
    const event = new CustomEvent("ieltsTypeChanged", { detail: { ieltsType: newIeltsType } });
    window.dispatchEvent(event);
    
    // For now, we're not implementing any navigation or functionality on toggle
    // Just updating the state and localStorage
  };

  return (
    <ToggleContainer>
      <Slider isActive={active} />
      <LeftButton isActive={active === 0} onClick={() => handleClick(0)}>
        General
      </LeftButton>
      <RightButton isActive={active === 1} onClick={() => handleClick(1)}>
        Academic
      </RightButton>
    </ToggleContainer>
  );
};

export default IeltsToggle; 